module.exports = __webpack_public_path__ + "5001f48e21eabf759ef872f9d41e6e44.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/KP.svg
// module id = ZRxJ
// module chunks = 0